export const CONFLICT_FILTERS = {
  OPEN: 'open',
  OPPORTUNITIES: 'opportunities',
  PENDING: 'pending',
  RESOLVED: 'resolved',
  OUT_OF_DATE: 'out of date'
};

export const DEFAULT_FILTERS = {
  [CONFLICT_FILTERS.OPEN]: true,
  [CONFLICT_FILTERS.OPPORTUNITIES]: true,
  [CONFLICT_FILTERS.PENDING]: true,
  [CONFLICT_FILTERS.RESOLVED]: false,
  [CONFLICT_FILTERS.OUT_OF_DATE]: false
};
